import type { AutopilotClient } from '@llmor/autopilot-core';
import type { AutopilotFunctionContext, AutopilotFunctionFactory } from './types';
import { createNavigateFunction } from './navigate';
import { createOpenLinkFunction } from './navigateToEntity';

export type { AutopilotFunctionContext, AutopilotFunctionFactory, AutopilotFunctionInput } from './types';

// Pinia unwraps the store's `client` to a structural type, so accept anything that can
// register/unregister a function rather than the full class instance.
export type FunctionRegistrar = Pick<AutopilotClient, 'registerFunction' | 'unregisterFunction'>;

/**
 * Global autopilot functions available in every conversation. Add a new function by
 * creating a module in this directory and appending its factory here.
 */
export const globalAutopilotFunctions: AutopilotFunctionFactory[] = [createNavigateFunction, createOpenLinkFunction];

/**
 * Registers all global functions on the given client. Safe to call once per app load.
 */
export function registerGlobalFunctions(client: FunctionRegistrar, ctx: AutopilotFunctionContext): void {
  for (const factory of globalAutopilotFunctions) {
    client.registerFunction(factory(ctx));
  }
}
